import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { AppService } from '@App';
import { AccountSettingsDTO } from '@DTOs';
import { Account, UWResponse } from '@Models';
import { BaseService } from '@Services';
import { IConfigService } from 'app/config/iconfigservice';
import { first, ReplaySubject } from 'rxjs';
import { SubSink } from 'subsink';


@Injectable({
    providedIn: 'root'
})
export default class AccountSettingsDataService extends BaseService implements OnDestroy {
    forceReload = false;

    private accountSettingsCache = new Map<string, ReplaySubject<AccountSettingsDTO[]>>();

    activeAccount: Account;

    subs = new SubSink();

    constructor(
        public configService: IConfigService,
        public httpClient: HttpClient,
        public appService: AppService
    ) {
        super(appService, configService, httpClient);
    }

    //#region Helpers

    private isAccountSettingsLoaded = (accountId: string) => this.accountSettingsCache.has(accountId);

    //#endregion
    //#region Lifecycle

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    //#endregion

    public forceOnNextLoad(accountId: string) {
        this.forceReload = true;
        this.accountSettingsCache.delete(accountId);
    }

    public reloadAccountSettings(accountId: string, hideWaiting?: boolean, clientid?: string) {
        this.forceReload = false;
        const url = new URL(`./AccountSettings/${accountId}`, this.baseApiUrl);
        let subject = this.accountSettingsCache.get(accountId);
        if (!subject) {
            subject = new ReplaySubject<AccountSettingsDTO[]>(1);
            this.accountSettingsCache.set(accountId, subject);
        }
        super.getData<UWResponse<AccountSettingsDTO[]>>(url.toString(), clientid, hideWaiting)
            .pipe(first())
            .subscribe(response => {
                subject!.next(response.data);
            });
        return subject.asObservable();
    }

    public loadAccountSettings(accountId: string, clientid?: string, hideWaiting?: boolean ) {
        if (this.forceReload || !this.isAccountSettingsLoaded(accountId)) {
            return this.reloadAccountSettings(accountId, hideWaiting, clientid);
        }
        // Always return the observable for the specific accountId
        return this.accountSettingsCache.get(accountId)!.asObservable();
    }
    
}
